<div class="welcome-screen">
    <div>
        <!-- shiva style:  <img src="/images/logo.png"> -->
        <img src="/images/gnvert-style/logo_engie-solutions.svg">
    </div>
    <div class="welcome-title" [translate]="'home.gnvert.welcome'"></div>
    <div class="welcome-text" [translate]="'home.gnvert.welcomeText'"></div>
        <div class="welcome-text" style="font-weight: bold;">{{VERSION}}</div>
</div>
